
import { Check, ChevronDown } from "lucide-react";
import { Card } from "./ui/card";
import { PollStatus } from "@/types/Poll";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "./ui/collapsible";
import { useState } from "react";

interface PollStagesProps {
  status: PollStatus;
}

export const PollStages = ({ status }: PollStagesProps) => {
  // Changed the default state to true so it's open by default
  const [isOpen, setIsOpen] = useState(true);

  const steps = [
    {
      id: 1,
      name: "Published",
      description: "Poll is active",
      checked: status >= PollStatus.active,
    },
    {
      id: 2,
      name: "Finished",
      description: "Waiting for rewards",
      checked: status >= PollStatus.pending,
    },
    {
      id: 3,
      name: "Completed",
      description: "Rewards distributed",
      checked: status >= PollStatus.completed,
    },
  ];

  return (
    <Card className="p-6 dark:bg-gray-800/50 dark:border-gray-700">
      <Collapsible
        open={isOpen}
        onOpenChange={setIsOpen}
        className="w-full"
      >
        <CollapsibleTrigger className="flex items-center justify-between w-full text-left">
          <h2 className="text-xl font-semibold dark:text-white">Poll Status</h2>
          <ChevronDown className={`h-5 w-5 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} />
        </CollapsibleTrigger>
        <CollapsibleContent className="mt-4">
          <div className="relative">
            <div 
              className="absolute left-4 top-0 h-full w-0.5 bg-gray-200 dark:bg-gray-700"
              aria-hidden="true"
            />
            <ul className="space-y-6 relative">
              {steps.map((step) => (
                <li key={step.id} className="relative flex items-start">
                  <div className="absolute flex h-8 w-8 items-center justify-center">
                    <div 
                      className={`h-8 w-8 rounded-full flex items-center justify-center ${
                        step.checked 
                          ? "bg-green-100 dark:bg-green-900/30" 
                          : "bg-red-50 dark:bg-red-900/10 border-2 border-gray-300 dark:border-gray-600"
                      }`}
                    >
                      {step.checked ? (
                        <Check className="h-5 w-5 text-green-600 dark:text-green-400" />
                      ) : (
                        <span className="h-2 w-2 rounded-full bg-red-200 dark:bg-red-800/30" />
                      )}
                    </div>
                  </div>
                  <div className="ml-12">
                    <h3 className={`text-base font-medium ${
                      step.checked ? "text-gray-900 dark:text-white" : "text-gray-500 dark:text-gray-400"
                    }`}>
                      {step.name}
                    </h3>
                    <p className="text-sm text-gray-500 dark:text-gray-400">
                      {step.description}
                    </p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </CollapsibleContent>
      </Collapsible>
    </Card>
  );
};
